import store from '@/ui/store';
import {Store} from 'vuex';
import {AuthApi} from '@/infrastructure/AuthApi';
import {isValidEmail} from '@/application/helper/validation';

class AuthServiceSingleton {
  private static instance: AuthServiceSingleton;
  private readonly store: Store<any>;
  private readonly authApi: AuthApi;

  private constructor() {
    this.store = store;
    this.authApi = new AuthApi()
  }

  public static getInstance(): AuthServiceSingleton {
    if (!AuthServiceSingleton.instance) AuthServiceSingleton.instance = new AuthServiceSingleton();

    return AuthServiceSingleton.instance;
  }

  public async register(displayName: string, email: string, password: string) {
    if (displayName.length < 2)
      throw new Error('Der Spitzname muss mindestens 2 Zeichen lang sein');

    if (!isValidEmail(email))
      throw new Error('Ungültige E-Mail-Adresse.');

    if (password.length < 6)
      throw new Error('Das Passwort muss mindestens 6 Zeichen lang sein');

    try {
      await this.authApi.registerApi(displayName, email, password);
      this.store.getters.loggedInUser.displayName = displayName; //Add displayName here because firebase logged in event is fired before updating user credentials
    } catch (error) {
      console.log(error);
      throw new Error('Diese E-Mail-Adresse wird bereits verwendet.')
    }
  }

  public async updateDisplayName(displayName: string) {
    const user = this.authApi.getCurrentUser();
    await this.authApi.updateDisplayName(user!, displayName)
  }

  public async login(email: string, password: string) {
    if (!isValidEmail(email))
      throw new Error('Ungültige E-Mail-Adresse');

    if (password.length < 6)
      throw new Error('Das Passwort muss mindestens 6 Zeichen lang sein');

    try {
      await this.authApi.loginApi(email, password);
    } catch (error) {
      console.log(error);
      throw new Error('Das Passwort oder die E-Mail-Adresse ist falsch.')
    }
  }

  public async logout() {
    this.store.commit('setGame', null);
    await this.authApi.logoutApi();
  }
}

export const AuthService = AuthServiceSingleton.getInstance();

